import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

// This is a wrapper component to be used in MUI-Datatable as a checkbox replacement so that the tests can interact with the checkboxes properly.
const CheckboxWithId = (props) => {
  const newProps = { ...props };
  let testId = 'select-all-rows';
  if (props['data-description'] === 'row-select') {
    if (props['data-index'] === null) {
      testId = 'select-row-0';
    } else {
      testId = `select-row-${props['data-index']}`;
    }
  }
  return <Checkbox {...newProps} inputProps={{ 'data-testid': testId }} />;
};

export default CheckboxWithId;
